"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createTextApi;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _nodePolyglot = _interopRequireDefault(require("node-polyglot"));
var _markdownToJsx = _interopRequireDefault(require("markdown-to-jsx"));
var _typ = require("./typ");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const HyperLink = _styledComponents.default.a.withConfig({
  displayName: "HyperLink",
  componentId: "sc-1k5zjow-0"
})(["color:#00ab97;"]);
const List = _styledComponents.default.ul.withConfig({
  displayName: "List",
  componentId: "sc-1k5zjow-1"
})(["li{margin-bottom:10px;}"]);
const Paragraph = (0, _styledComponents.default)(_typ.Typ30).withConfig({
  displayName: "Paragraph",
  componentId: "sc-1k5zjow-2"
})(["display:block;padding-top:16px;width:100%;&:first-child{margin-top:0;}&:last-child{margin-bottom:0;}"]);
const H1 = (0, _styledComponents.default)(_typ.Typ50).withConfig({
  displayName: "H1",
  componentId: "sc-1k5zjow-3"
})(["padding-top:60px;width:100%;"]);
const H2 = (0, _styledComponents.default)(_typ.Typ41).withConfig({
  displayName: "H2",
  componentId: "sc-1k5zjow-4"
})(["padding-top:40px;width:100%;"]);
const H3 = (0, _styledComponents.default)(_typ.Typ41).withConfig({
  displayName: "H3",
  componentId: "sc-1k5zjow-5"
})(["display:block;padding-top:16px;width:100%;&:first-child{padding-top:0;}"]);
const defaultOptions = {
  overrides: {
    h1: H1,
    h2: H2,
    h3: H3,
    ul: List,
    a: {
      component: HyperLink,
      props: {
        target: '_blank',
        rel: 'noreferrer noopener'
      }
    },
    p: Paragraph
  }
};
function createTextApi(language, onMissingTextCallback, options = defaultOptions) {
  function markdown(text = '') {
    return /*#__PURE__*/_react.default.createElement(_markdownToJsx.default, {
      options: options
    }, text.replace('MARKDOWN:', ''));
  }
  const polyglot = new _nodePolyglot.default({
    phrases: language.phrases,
    locale: language.locale
  });
  const t = function t(...args) {
    if (!polyglot.has(args[0])) {
      if (onMissingTextCallback) {
        onMissingTextCallback(`Missing translation (${polyglot.locale()}) for: ${args[0]}`);
      }
      return null;
    }
    const text = polyglot.t(...args);
    if (text.substr(0, 9) === 'MARKDOWN:') {
      return /*#__PURE__*/_react.default.createElement(_markdownToJsx.default, {
        options: options
      }, text.replace('MARKDOWN:', ''));
    }
    return text;
  };
  t.phrases = language.phrases;
  t.countries = language.phrases.countries;
  t.locale = language.locale;
  t.fullLocale = language.fullLocale;
  t.has = path => polyglot.has(path);
  t.markdown = markdown;
  return t;
}
//# sourceMappingURL=createTextApi.js.map